import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { toast } from 'react-toastify';

const ZoneTabBar = ({ zones, activeZoneId, onSelectZone, onZonesReordered, onAddZone, onEditZone, extraTabs = [] }) => {
  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reordered = Array.from(zones);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    const withSortOrder = reordered.map((zone, index) => ({ ...zone, sort_order: index }));
    onZonesReordered(withSortOrder);

    try {
      await callAPI(
        apiUrls.ZONES_REORDER,
        {},
        'POST',
        withSortOrder.map((z) => ({ id: z.id, sort_order: z.sort_order })),
        {}
      );
    } catch (err) {
      console.error('Failed to reorder zones', err);
      toast.error('Failed to save zone order');
    }
  };

  return (
    <div className="zoneTabBar">
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="zone-tabs" direction="horizontal">
          {(provided) => (
            <div className="zoneTabList" ref={provided.innerRef} {...provided.droppableProps}>
              {zones.map((zone, index) => (
                <Draggable key={zone.id} draggableId={String(zone.id)} index={index}>
                  {(dragProvided) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      {...dragProvided.dragHandleProps}
                      className={`zoneTab${activeZoneId === zone.id ? ' active' : ''}`}
                    >
                      <button
                        type="button"
                        className="zoneTabButton"
                        onClick={() => onSelectZone(zone.id)}
                      >
                        <span className="zoneTabDot" style={{ background: zone.color || 'var(--primary, #e94059)' }} />
                        {zone.name}
                      </button>
                      <button
                        type="button"
                        className="zoneTabEditBtn"
                        title="Edit zone"
                        onClick={() => onEditZone(zone)}
                      >
                        ✎
                      </button>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <button type="button" className="zoneTabAddBtn" onClick={onAddZone}>
        + Add Zone
      </button>

      {/* Fixed system categories (Person/Tabs/Takeaway) — not physical sections, so no canvas,
          no drag-reorder, and no rename/delete here; only their tables are manageable. */}
      {extraTabs.map((tab) => (
        <div
          key={tab.id}
          className={`zoneTab${activeZoneId === tab.id ? ' active' : ''}`}
        >
          <button type="button" className="zoneTabButton" onClick={() => onSelectZone(tab.id)}>
            <span className="zoneTabDot" style={{ background: tab.color || 'rgba(255, 255, 255, 0.35)' }} />
            {tab.name}
          </button>
          <button
            type="button"
            className="zoneTabEditBtn"
            title="Edit category"
            onClick={() => onEditZone(tab)}
          >
            ✎
          </button>
        </div>
      ))}
    </div>
  );
};

export default ZoneTabBar;
